import React from "react";
import { makeStyles, Skeleton, SkeletonItem, tokens } from "@fluentui/react-components";

const SKELETON_ROW_COUNT = 5;

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        gap: "2px",
        paddingTop: "4px",
    },
    row: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        height: "32px",
        paddingLeft: "4px",
        paddingRight: "4px",
    },
    checkbox: {
        width: "16px",
        height: "16px",
        borderRadius: "2px",
        flexShrink: 0,
    },
    icon: {
        width: "20px",
        height: "20px",
        borderRadius: "4px",
        flexShrink: 0,
    },
    label: {
        height: "12px",
        borderRadius: tokens.borderRadiusSmall,
        flex: 1,
    },
});

export const ProjectFilesBrowserSkeleton: React.FC = () => {
    const styles = useStyles();

    return (
        <div className={styles.container} aria-busy="true" aria-label="Loading files">
            {Array.from({ length: SKELETON_ROW_COUNT }).map((_, index) => (
                <Skeleton key={index} className={styles.row}>
                    <SkeletonItem className={styles.checkbox} />
                    <SkeletonItem className={styles.icon} />
                    {/* Vary label widths slightly to look more natural */}
                    <SkeletonItem className={styles.label} style={{ maxWidth: `${60 + (index % 3) * 15}%` }} />
                </Skeleton>
            ))}
        </div>
    );
};
